__turbopack_context__.v({
  "fade-in": "Spinner-module__8oBgdW__fade-in",
  "spin-in": "Spinner-module__8oBgdW__spin-in",
  "spinner": "Spinner-module__8oBgdW__spinner",
  "svg-wrapper": "Spinner-module__8oBgdW__svg-wrapper",
  "text": "Spinner-module__8oBgdW__text",
});
